module.exports = {
  common: {
    yeardate_label: 'Edition year {year}',
    metal: {
      silver: 'silver',
      gold: 'gold',
    },
    devise: 'euros',
    reminder: {
      cta: 'Create a reminder',
      title: 'Add to my calendar',
      text: 'Add the coin’s release date to get notified at launch.',
      event: {
        title: 'Launch of {value} euros {metal} coin "{collection}"',
        description: 'Reserve your {value} euros pure {metal} coin "{collection}". Visit {link}',
        location: '2 bis, rue Guénégaud, 75006 Paris',
      },
    },
    timer: {
      days: 'Days',
      hours: 'Hours',
      minutes: 'Minutes',
    },
    subscription: '<strong>{days}</strong>days at<em>{value}€</em>',
    legals: 'to purchase your coin at its face value.',
    faq: {
      title: "<b>'The French Genius':</b> precious values to pass on.",
      cta: 'Why buying a coin\nwith a face value?',
      items: [
        {
          question: 'A real coin',
          answer: 'These collectibles are, first and foremost, genuine coins that are legal tender in France. They can be exchanged at any time at the Bank of France.',
        },
        {
          question: 'a secure savings',
          answer: 'These limited-edition coins will always be worth at least their face value. They may also appreciate in value over time. They combine all the qualities suitable for safe and sensible diversification of savings.',
        },
        {
          question: 'An exceptional gift',
          answer: 'These coins bear witness to the inimitable, thousand-year-old expertise of the craftsmen at Monnaie de Paris. The great care taken with every detail will delight collectors keen to acquire a genuine work of art and build up a precious heritage to preserve or pass on.',
        },
      ],
      back: 'Back to collections',
    },
  },

  home: {
    h2: 'The Trilogy of the French Genius',
    liberty: {
      claim: 'Offer the Genius of Liberty, the first edition in the French Genius trilogy. Depicted naked with angel wings, the Genius is an allegory of Liberation. In his right hand, he proudly raises a torch, symbol of the light that will guide the people, while his left hand grasps a broken chain.',
    },
    equality: {
      claim: 'Offer the Genius of the Constitution, the second edition in the French Genius trilogy. This coin embodies Equality for all, a fundamental value of our Republic.',
    },
    fraternity: {
      claim: 'Offer the Genius of Fraternity, the final coin in the French Genius trilogy. This edition pays tribute to Fraternity through the figure of an armed Genius. With his sword and shield, he protects the people and defends the bonds that unite all French citizens.',
    },
    h4: 'The coins',
    nav: 'The Trilogy of the French Genius',
  },
  teaser: {
    liberty: '',
    equality: 'In 2027, the trilogy will celebrate the Genius of the Constitution, an iconic work by engraver Augustin Dupré, already featured on historical and collector coins. This symbol, which engraves the French Constitution, embodies the value of Equality in the French motto.',
    fraternity: 'The year 2028 will mark the conclusion of this trilogy with the minting, for the first time, of a new Genie by Augustin Dupré. Designed by the Monnaie de Paris, this Genie, symbol of Fraternity, will be minted on a coin for the first time.',
  },
  product: {
    navTitle: 'The other coins',
    available_in: 'Coming in {year}',
    legal: 'Given the high volatility of precious metal prices, the sale of the product may be suspended if the metal value exceeds the selling price. Applicable rates may be increased without prior notice.',
  },
  history: {
    cta: 'Learn more about\nthe French Genius trilogy.',
    title: 'Discover the origins and inspirations behind our new collection.',
  },
};
